import type { MarkerColor, MarkerKind } from '@concept/protocol';

export type MarkerInventoryRules = {
  limitCubes: boolean;
  cubeLimits: Readonly<Record<MarkerColor, number>>;
};

// Change this one flag to switch cube inventory limits for both the domain
// rules and the board placement UI. Pawns remain one-per-color either way.
export const MARKER_INVENTORY_RULES: MarkerInventoryRules = {
  limitCubes: true,
  cubeLimits: {
    green: 10,
    blue: 8,
    red: 8,
    yellow: 8,
    black: 8,
  },
};

export function markerInventoryLimit(
  color: MarkerColor,
  kind: MarkerKind,
  rules: MarkerInventoryRules = MARKER_INVENTORY_RULES,
): number | null {
  if (kind === 'pawn') return 1;
  return rules.limitCubes ? rules.cubeLimits[color] : null;
}
